export default "__VITE_ASSET__d8f8b356__"